import React from 'react'
import ModalButton from '../BarrierErrorModal/ModalButton'
import WarningGreenSvg from '../../../assets/icons/WarningGreenSvg'
import WarningOrangeSvg from '../../../assets/icons/WarningOrangeSvg'
import RedoWhiteSvg from '../../../assets/icons/RedoWhiteSvg'

const SuccessModalBody = ({ error, toggle }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '.5rem',
        padding: '.6rem 0 0 0',
      }}
    >
      {error === '' ? (
        <WarningGreenSvg width={'4rem'} />
      ) : (
        <WarningOrangeSvg width={'4rem'} />
      )}
      <div
        style={{
          fontSize: '20px',
          fontWeight: '700',
        }}
      >
        {error === '' ? 'Bilgi' : 'Servis Hatası'}
      </div>
      <div
        style={{
          lineHeight: 1,
          fontWeight: '300',
        }}
      >
        {error === ''
          ? 'Giriş bağlantısını içeren kısa mesaj tekrar gönderildi.'
          : 'Hata açıklaması'}
      </div>
      {error !== '' && (
        <div style={{ width: '100%' }}>
          <ModalButton
            backgroundColor={'#E66725'}
            text={'Tekrar Dene'}
            icon={<RedoWhiteSvg width={'1.5rem'} />}
            onClick={() => {
              toggle()
              // console.log('location: ', location)
            }}
          />
        </div>
      )}
    </div>
  )
}

export default SuccessModalBody
